<div class="multiple-select-question">
  <div class="question" *ngFor="let question of data.questions">
    <div class="default-text">
      {{question.text}}
    </div>
    <span class="select-layer" [ngClass]="{'disabled': !active}">
      <select class="app-select" [disabled]="!active"
              (change)="onMultipleSelectQuestionTestSelected(question.id, $event.target.value)">
        <option [value]="answer.id" *ngFor="let answer of question.answers"
                [selected]="isOptionSelected(question.id, answer.id)">
          {{answer.value}}
        </option>
      </select>
    </span>
  </div>
</div>
